export const API_BASE_URL = "https://pixeous.ai";

export const HIDE_SIGNUP = false;
